<template>
  <TaskForm :task="task" :onSubmit="submit"></TaskForm>
</template>

<script>
import TaskForm from './Task-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'edit-task',
  components: {
    TaskForm,
  },
  created() {
    this.$store.dispatch('tasks/getTask', this.$route.params.id);
  },
  computed: {
    task() {
      const currentTask = this.$store.state.tasks.task;
      currentTask.sendNotification = true;
      return currentTask;
    },
  },

  watch: {
    task() {
      if (this.task.clientId) {
        this.$store.dispatch('clients/getClientOfTask', this.task.clientId);
      }
    },
  },

  methods: {
    submit() {
      this.$store
        .dispatch('tasks/updateTask', {
          id: this.$route.params.id,
          body: this.task,
        })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
          this.$router.push({ path: '/tasks' });
        });
    },
  },
};
</script>
